import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { SettingsIcon } from "@/shared/icons";
import { setSettingsOpen } from "@/domains/chat/slice";
import ChatControlButton from "@/domains/chat/components/chat/controls/ChatControlButton";

export default function ChatSettingsOpenToggleContainer() {
  const dispatch = useAppDispatch();

  const onClickHandler = useCallback(() => dispatch(setSettingsOpen(true)), [dispatch]);

  return (
    <ChatControlButton onClick={onClickHandler}>
      <SettingsIcon size={16} className="text-white/60 group-hover:text-white transition" />
    </ChatControlButton>
  );
}
